import React, { useState } from "react";
import moment from "moment-jalaali";
import "./style.css";
import axios from "axios";
import { useEffect } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function QuickPurchaseModal({ closeModal, selectedUser }) {
  const [productCount, setProductCount] = useState(1);
  const [userDiscount, setUserDiscount] = useState("");
  const [discountError, setDiscountError] = useState(false);
  const [discountErrorMessage, setDiscountErrorMessage] = useState("");
  const [productDiscount, setProductDiscount] = useState(0);
  const [productName, setProductName] = useState("SCOBO");
  const [productPrice, setProductPrice] = useState(500000);
  const [productPriceString, setProductPriceString] = useState("۵۰,۰۰۰");

  const setDiscountCode = () => {
    if (userDiscount === "AP8898PA") {
      setProductPrice(100000);
      setProductPriceString("۱۰,۰۰۰");
    } else {
      setDiscountError(true);
      setDiscountErrorMessage("کد وارد شده معتبر نمی‌باشد");
    }
  };

  const submitPayment = async () => {
    const result = await axios.post(
      "https://request.kidiar.com/evaluation/create",
      { audienceId: 0, sessionName: "SCOBO" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (result.data.status == 0) {
      return;
    }

    const response = await axios.post(
      "https://request.kidiar.com/evaluation/start",
      { audienceId: 0, testName: "SCOBO" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 1)
      window.location.href = "/en/panel/evaluations/scobo";
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-title">Start a Test</div>
        <div className="modal-content">
          <div className="d-flex">
            <div
              className="panel-card d-flex align-items-center ml-2 mb-2 font-18 mode-text-1 w-100"
              style={{
                minWidth: "100px",
                minHeight: "100px",
                border: "solid",
                borderColor: productName == "SCOBO" ? "black" : "white",
              }}
              onClick={() => {
                setProductName("SCOBO");
              }}
            >
              AI Powered Autism Screening
            </div>
          </div>
        </div>
        <div className="modal-footer mt-4 mode-bg-8">
          <button onClick={() => closeModal(false)}>Cancel</button>
          <button onClick={() => submitPayment()}>Start</button>
        </div>
        <div className="error-text"></div>
      </div>
    </div>
  );
}

export default QuickPurchaseModal;
